/* eslint-disable no-process-env */
// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments
export const APP_VERSION = '2.0.0';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const TENANT_URL = process.env.REACT_APP_TENANT_URL;
export const ENABLE_REDUX_LOGGER = false;
export { default as routes } from './api.routes';
export default {};
